import { type ReactNode } from 'react';
import { Switch as HeadlessSwitch } from '@headlessui/react';
import { Paragraph } from '@hungryroot/ui-kit';
import styles from './Switch.module.css';

type Props = {
  testid?: string;
  label: string;
  disableSwitch?: boolean;
  icon?: ReactNode;
  subtext?: string | null;
  onClick?: () => void;
  enabled: boolean;
  onChange: (value: boolean) => void;
};

export const Switch = (props: Props) => {
  const {
    testid,
    label,
    disableSwitch,
    icon,
    subtext,
    onClick,
    enabled,
    onChange,
  } = props;

  return (
    <HeadlessSwitch.Group>
      <div className={styles['switch-group']}>
        <div className={styles['icon-text-wrapper']}>
          {icon}

          <div className={styles['text-wrapper']}>
            <Paragraph>
              <HeadlessSwitch.Label
                data-testid={`${testid}-switch-label`}
                passive
              >
                {label}
              </HeadlessSwitch.Label>
            </Paragraph>
            {subtext ? (
              <Paragraph
                testid={`${testid}-switch-subtext`}
                className={styles.subtext}
              >
                {subtext}
              </Paragraph>
            ) : null}
          </div>
        </div>
        <HeadlessSwitch
          checked={enabled}
          onChange={onChange}
          className={enabled ? styles.on : styles.off}
          disabled={disableSwitch}
          data-testid={`${testid}-switch`}
          onClick={onClick}
        >
          <span
            aria-hidden="true"
            className={enabled ? styles['switch-on'] : styles.switch}
          />
        </HeadlessSwitch>
      </div>
    </HeadlessSwitch.Group>
  );
};
